import { metadataLoader, MetadataLoader } from "../metadata";

import { setupI18n } from "@lingui/core";

/* One singleton per app */
class I18ndb extends MetadataLoader {

	static i18n;
	static catalog;

	constructor(props) {
		super(props)		
	}
	postLoad = (data) => {
		if(data.length) {
			let i18nMessages = transform2I18nMessages(data);
			let localeId = data[0].localeId;
			this.i18n = setupI18n();
			let localIdValue = metadataLoader.getDefaultDto2ViewTransformer('locale')[localeId];
			this.i18n.activate(localIdValue);
			let catalog = {};
			catalog[localIdValue] = {};
			catalog[localIdValue]['messages'] = i18nMessages;
			this.i18n.load(catalog);
		}
	}
	
	getCatalog = () => this.i18n._catalogs;
	
	_ = (msg) => this.i18n._({
		id: msg
	});
}

export const i18ndb = new I18ndb();
export function t(msg) { 
	let trans = i18ndb._(msg);
	if (trans!=msg)
		return trans;
	else {
		if (typeof msg === 'string' || msg instanceof String)
			return msg
		else
			//assume it's a string wrapped in an object
			return msg[0];
	}
};

function transform2I18nMessages(data) {
	let messages = {};
	data.forEach(element => {
		messages[element.messageId] = element.value;
	});
	return messages;
} 